import React, { VFC } from "react";

import Transition from "../../components/particles/Transition";
import Box from "../../components/particles/Box";
import ConnectedPages from "../../components/templates/ConnectedPages";
import ConnectionsOnboardingSlider from "../../components/templates/ConnectionsOnboardingSlider";

import { BoxBorderedStyled } from './styled';
import ConnectFinnSection from '../../components/templates/ConnectFinnSection';

interface ConnectionsComponentProps {
  isCommunity: boolean;
  pages: {
    id: number;
    remote_id?: string;
    name?: string;
    url: string;
    titleAs?: string;
    author?: string;
    type: "facebook" | "instagram";
    enabled: boolean;
    syncError: boolean;
    authError: boolean;
  }[];
  filteringEnabled: boolean;
  filteringHashtag?: string;
  setPages: any;
  storeModal: any;
  resetModal: () => void;
  connectPages: () => void;
  connectMorePages: () => void;
  reconnectPages: () => void;
  isEnabledDuplicate: (pageName: string) => boolean;
  finnEnabled: boolean;
  finnConnecting: boolean;
  finnStatus: { id?: number; remote_id?: string, fetching_enabled?: boolean } | null;
  connectFinn: (finnAccount: { id: string; token: string }) => void;
}

const ConnectionsComponent: VFC<ConnectionsComponentProps> = ({
  isCommunity,
  pages,
  setPages,
  storeModal,
  resetModal,
  connectPages,
  connectMorePages,
  reconnectPages,
  filteringEnabled,
  filteringHashtag,
  isEnabledDuplicate,
  finnEnabled,
  finnConnecting,
  finnStatus,
  connectFinn
}) => {
  return (
    <Transition>
      {pages?.length ? (
        <Box marginH={2}>
          <ConnectedPages
            isCommunity={isCommunity}
            pages={pages}
            setPages={setPages}
            storeModal={storeModal}
            resetModal={resetModal}
            connectAction={connectMorePages}
            reconnectAction={reconnectPages}
            isEnabledDuplicate={isEnabledDuplicate}
          />
        </Box>
      ) : (
        <Box marginT={3} marginB={3} marginH={1}>
          <BoxBorderedStyled>
            <ConnectionsOnboardingSlider
              isCommunity={isCommunity}
              filteringEnabled={filteringEnabled}
              filteringHashtag={filteringHashtag}
              connectAction={connectPages}
            />
          </BoxBorderedStyled>
        </Box>
      )}
      <ConnectFinnSection
        finnEnabled={finnEnabled}
        finnConnecting={finnConnecting}
        finnStatus={finnStatus}
        connectFinn={connectFinn}
      />
    </Transition>
  );
};

export default ConnectionsComponent;
